import React, { useRef, useState, useEffect } from "react";
import { useHistory } from "react-router-dom"; // use react-router-dom
import ActionButtons from "../components/ActionButtons";
import Header from "../components/Header";
import Loader from "../components/Loader";
import { fields, LOCAL_STORAGE_KEY } from "../constants";
import { getDetailsApi } from "../utils/api";
import { mergeLookupDetails } from "../utils/lookupDetails";
import { randomNumber, formatDate } from "../utils/helper";
const Jharkhand = () => {
  const isLoggedIn = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEY) || "null");
  const history = useHistory();
  const state = "jharkhand";

  // all input fields
  const [payLoad, setPayLoad] = useState({
    vehicleNo: "",
    chassisNo: "",
    mobileNo: "",
    vehiclePermitType: "",
    seatingCapacityExcludingDriver: "",
    borderBarrier: "",
    checkpostName: "",
    totalAmount: "",
    ownerName: "",
    fromState: "",
    vehicleClass: "",
    vehicleCategory: "",
    taxMode: "",
    numberOfPeriod: "",
    taxFromDate: "",
    taxUptoDate: "",
    sleeperCapacityExcludingDriver: "",
    grossVehicleWeight: "",
    unladenWeight: "",
    serviceType: "",
    insuranceValidity: "",
    puccValidity: "",
    fitnessValidity: "",
    permitType: "NOT APPLICABLE",
    mvTax: "",
  });
  // all inputs fields
  const [isLoading, setIsLoading] = useState(false);
  const form = useRef(null);

  const getDetailsHandler = async () => {
    if (!payLoad.vehicleNo) {
      alert("Please enter vehicle no.");
      return;
    }

    setIsLoading(true);
    const { data } = await getDetailsApi({
      vehicleNo: payLoad.vehicleNo,
    });
    setIsLoading(false);
    if (data && data.success) {
setPayLoad((e) => ({
        ...e,
        ...mergeLookupDetails(e, data.detail),
      }));
    }
  };

  const onChangeHandler = (e) => {
    setPayLoad((old) => ({ ...old, [e.target.name]: e.target.value }));
  };

  useEffect(() => {
    setPayLoad((prev) => ({
      ...prev,
      totalAmount: prev.mvTax || "",
    }));
  }, [payLoad.mvTax]);


  const onSubmitHandler = async (e) => {
    e.preventDefault();
    if (!payLoad.unladenWeight) {
      payLoad.unladenWeight = 0;
    }
    payLoad.bankRefNo = randomNumber(8);

    history.push("/select-payment", {
      formData: {
        ...payLoad,
        state,
      },
    });
  };

  const onResetHandler = () => {
    let x = { ...payLoad };
    let p = {};
    Object.keys(x).forEach((e) => {
      p[e] = "";
    });
    setPayLoad({ ...p });
  };

  // Guard the isLoggedIn check and use jharkhand
  if (!isLoggedIn || !isLoggedIn.accessState || !isLoggedIn.accessState.includes(fields.stateName.jharkhand)) {
    return (
      <>
        <Header />
        <div className="container text-center mt-4 ">
          <h3>No Access of this state</h3>
        </div>
      </>
    );
  }
  return (
    <>
      <Header />
      <div className="text-center">
        <p className="login-heading mt-4">
          <b>BORDER TAX PAYMENT FOR ENTRY INTO</b> <span>JHARKHAND</span>
        </p>
      </div>
      <div className="box box--main">
        <div className="box__heading--blue">Tax Payment Details</div>
        <form
          ref={form}
          onSubmit={onSubmitHandler}
          className="service-type tax-details mt-4"
        >
          <div className="row">
            <div className="col-6">
              {/* <!-- vehicle number --> */}
              <div className="form__control">
                <label
                  className="form__label d-block w-100 text-left"
                  htmlFor="vehicleNo"
                >
                  Vehicle No.<sup>*</sup>
                </label>
                <input
                  tabIndex="1"
                  required
                  inputMode="text"
                  disabled={isLoading}
                  maxLength="10"
                  autoFocus
                  value={payLoad.vehicleNo}
                  onChange={onChangeHandler}
                  className="form__input w-100"
                  type="text"
                  id="vehicleNo"
                  name="vehicleNo"
                />
              </div>
              {/* <!-- chassis number --> */}
              <div className="form__control">
                <label
                  className="form__label d-block w-100 text-left"
                  htmlFor="chassisNo"
                >
                  Chassis No.<sup>*</sup>
                </label>
                <input
                  tabIndex="2"
                  required
                  maxLength="19"
                  inputMode="text"
                  disabled={isLoading}
                  onChange={onChangeHandler}
                  value={payLoad.chassisNo}
                  className="form__input w-100"
                  type="text"
                  id="chassisNo"
                  name="chassisNo"
                />
              </div>
              {/* <!-- mobile number --> */}
              <div className="form__control">
                <label
                  className="form__label d-block w-100 text-left"
                  htmlFor="mobileNo"
                >
                  Mobile No.<sup>*</sup>
                </label>
                <input
                  tabIndex="3"
                  required
                  disabled={isLoading}
                  placeholder="SMS about payment will be sent to this number "
                  className="form__input w-100"
                  type="text"
                  id="mobileNo"
                  inputMode="tel"
                  value={payLoad.mobileNo}
                  onChange={onChangeHandler}
                  maxLength="10"
                  minLength="10"
                  name="mobileNo"
                />
              </div>
              {/* <!-- vehicle permit type --> */}
              <div className="form__control">
                <label
                  className="form__label d-block w-100 text-left"
                  htmlFor="vehiclePermitType"
                >
                  vehicle Permit Type<sup>*</sup>
                </label>
                <select
                  tabIndex="4"
                  required
                  disabled={isLoading}
                  inputMode="text"
                  value={payLoad.vehiclePermitType}
                  onChange={onChangeHandler}
                  name="vehiclePermitType"
                  id="vehiclePermitType"
                >
                  <option value="">--Select vehicle type--</option>
                  <option value="TRANSPORT">TRANSPORT</option>
                </select>
              </div>
              {["THREE WHEELER (PASSENGER)", "MOTOR CAB", "MAXI CAB", "OMNI BUS", "BUS"].includes(payLoad.vehicleClass) ? (
                <div className="row">
                  <div className="col-sm-6">
                    {/* <!-- seating capacity --> */}
                    <div className="form__control">
                      <label
                        className="form__label d-block w-100 text-left"
                        htmlFor="seatingCapacityExcludingDriver"
                      >
                        Seating Capacity(Excluding Driver)<sup>*</sup>
                      </label>
                      <input
                        tabIndex="5"
                        required
                        inputMode="numeric"
                        disabled={isLoading}
                        onChange={onChangeHandler}
                        className="form__input w-100"
                        type="number"
                        min="0"
                        value={payLoad.seatingCapacityExcludingDriver}
                        id="seatingCapacityExcludingDriver"
                        name="seatingCapacityExcludingDriver"
                      />
                    </div>
                  </div>
                  <div className="col-sm-6">
                    {/* <!-- sleeper capacity --> */}
                    <div className="form__control">
                      <label
                        className="form__label d-block w-100 text-left"
                        htmlFor="sleeperCapacityExcludingDriver"
                      >
                        Sleeper Capacity<sup>*</sup>
                      </label>
                      <input
                        tabIndex="6"
                        required
                        inputMode="numeric"
                        disabled={isLoading}
                        onChange={onChangeHandler}
                        className="form__input w-100"
                        type="number"
                        min="0"
                        value={payLoad.sleeperCapacityExcludingDriver}
                        id="sleeperCapacityExcludingDriver"
                        name="sleeperCapacityExcludingDriver"
                      />
                    </div>
                  </div>
                </div>
              ) : (
                <div className="row">
                  <div className="col-sm-6">
                    {/* <!-- gross vehicle wieght --> */}
                    <div className="form__control">
                      <label
                        className="form__label d-block w-100 text-left"
                        htmlFor="grossVehicleWeight"
                      >
                        Gross Vehicle Wt.(in kg)<sup>*</sup>
                      </label>
                      <input
                        tabIndex="5"
                        required
                        inputMode="numeric"
                        disabled={isLoading}
                        onChange={onChangeHandler}
                        className="form__input w-100"
                        type="number"
                        min="0"
                        value={payLoad.grossVehicleWeight}
                        id="grossVehicleWeight"
                        name="grossVehicleWeight"
                      />
                    </div>
                  </div>
                  <div className="col-sm-6">
                    {/* <!-- unladen weight --> */}
                    <div className="form__control">
                      <label
                        className="form__label d-block w-100 text-left"
                        htmlFor="unladenWeight"
                      >
                        Unladen Wt.(in kg)<sup>*</sup>
                      </label>
                      <input
                        tabIndex="6"
                        required
                        inputMode="numeric"
                        disabled={isLoading}
                        onChange={onChangeHandler}
                        className="form__input w-100"
                        type="number"
                        min="0"
                        value={payLoad.unladenWeight}
                        id="unladenWeight"
                        name="unladenWeight"
                      />
                    </div>
                  </div>
                </div>
              )}

              <div className="row">
                {/* <!-- Tax mode --> */}
                <div className="col-sm-6">
                  <div className="form__control">
                    <label
                      className="form__label d-block w-100 text-left"
                      htmlFor="taxMode"
                    >
                      Tax Mode<sup>*</sup>
                    </label>
                    <select
                      tabIndex="12"
                      disabled={isLoading}
                      required
                      onChange={onChangeHandler}
                      value={payLoad.taxMode}
                      name="taxMode"
                      id="taxMode"
                    >
                      <option value="">--Select Tax Mode--</option>
                      {fields.taxMode.map((type) => {
                        return (
                          <option value={type.name} key={type.name}>
                            {type.name}
                          </option>
                        );
                      })}
                    </select>
                  </div>
                </div>
                {/* <!-- No. of Period --> */}
                <div className="col-sm-6">
                  <div className="form__control">
                    <label
                      className="form__label d-block w-100 text-left"
                      htmlFor="numberOfPeriod"
                    >
                      No of Period
                    </label>
                    <input
                      disabled={isLoading}
                      tabIndex="11"
                      className="form__input w-100"
                      type="text"
                      value={payLoad.numberOfPeriod}
                      onChange={onChangeHandler}
                      id="numberOfPeriod"
                      name="numberOfPeriod"
                    />
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-sm-6">
                  {/* <!-- Border/barrier --> */}
                  <div className="form__control">
                    <label
                      className="form__label d-block w-100 text-left"
                      htmlFor="borderBarrier"
                    >
                      District Name<sup>*</sup>
                    </label>
                    <select
                      tabIndex="7"
                      value={payLoad.borderBarrier}
                      onChange={onChangeHandler}
                      name="borderBarrier"
                      id="borderBarrier"
                      disabled={isLoading}
                      required
                    >
                      <option value="">--Select District/Barrier--</option>
                      {fields.jharkhand.borderBarrier.map((type) => {
                        return (
                          <option value={type.name} key={type.name}>
                            {type.name}
                          </option>
                        );
                      })}
                    </select>
                  </div>
                </div>
                <div className="col-sm-6">
                  {/* <!-- Checkpost Name --> */}
                  <div className="form__control">
                    <label
                      className="form__label d-block w-100 text-left"
                      htmlFor="checkpostName"
                    >
                      Checkpost Name<sup>*</sup>
                    </label>
                    <select
                      tabIndex="8"
                      value={payLoad.checkpostName}
                      onChange={onChangeHandler}
                      name="checkpostName"
                      id="checkpostName"
                      disabled={isLoading}
                      required
                    >
                      <option value="">--Select Checkpost--</option>
                      {fields.jharkhand.borderBarrier.map((type) => {
                        return (
                          <option value={type.name} key={type.name}>
                            {type.name}
                          </option>
                        );
                      })}
                    </select>
                  </div>
                </div>
              </div>
            </div>
            {/* ============  right side form fields ================== */}
            <div className="col-6">
              <div className="form__control text-left">
                <label className="form__label d-block w-100 text-left">
                  &nbsp;
                </label>
                {isLoading && <Loader className="loader__get-details" />}
                {!isLoading && (
                  <button
                    disabled={isLoading}
                    type="button"
                    onClick={getDetailsHandler}
                    className="box__button get-details"
                  >
                    <span className="glyphicon glyphicon-arrow-down mr-3"></span>
                    Get Details
                  </button>
                )}
              </div>
              {/* <!-- owner name --> */}
              <div className="form__control">
                <label
                  className="form__label d-block w-100 text-left"
                  htmlFor="ownerName"
                >
                  Owner Name<sup>*</sup>
                </label>
                <input
                  tabIndex="8"
                  required
                  disabled={isLoading}
                  inputMode="text"
                  className="form__input w-100"
                  type="text"
                  id="ownerName"
                  name="ownerName"
                  onChange={onChangeHandler}
                  value={payLoad.ownerName}
                />
              </div>
              {/* <!-- from state --> */}
              <div className="form__control">
                <label
                  className="form__label d-block w-100 text-left"
                  htmlFor="fromState"
                >
                  From State<sup>*</sup>
                </label>
<select
                  tabIndex="9"
                  required
                  disabled={isLoading}
                  value={payLoad.fromState}
                  onChange={onChangeHandler}
                  name="fromState"
                  id="fromState"
                >
                  <option value="">--Select State--</option>
                  {fields.fromState.map((type) => {
                    return (
                      <option value={String(type.name).toUpperCase()} key={type.name}>
                        {type.name}
                      </option>
                    );
                  })}
                </select>
              </div>
              <div className="row">
                {/* <!-- vehicle class --> */}
                <div className="col-sm-6">
                  <div className="form__control">
                    <label
                      className="form__label d-block w-100 text-left"
                      htmlFor="vehicleClass"
                    >
                      Vehicle Class<sup>*</sup>
                    </label>
                    <select
                      tabIndex="10"
                      disabled={isLoading}
                      required
                      value={payLoad.vehicleClass}
                      onChange={onChangeHandler}
                      name="vehicleClass"
                      id="vehicleClass"
                    >
                      <option value="">--Select Vehicle Class--</option>
                      <option value="THREE WHEELER (PASSENGER)">
                        THREE WHEELER (PASSENGER)
                      </option>
                      <option value="MOTOR CAB">MOTOR CAB</option>
                      <option value="MAXI CAB">MAXI CAB</option>
                      <option value="OMNI BUS">OMNI BUS</option>
                      <option value="BUS">BUS</option>
                      <option value="GOODS CARRIER">GOODS CARRIER</option>
                    </select>
                  </div>
                </div>
                {/* <!-- vehicle category --> */}
                <div className="col-sm-6">
                  <div className="form__control">
                    <label
                      className="form__label d-block w-100 text-left"
                      htmlFor="vehicleCategory"
                    >
                      Vehicle Category<sup>*</sup>
                    </label>
                    <select
                      tabIndex="11"
                      disabled={isLoading}
                      required
                      value={payLoad.vehicleCategory}
                      onChange={onChangeHandler}
                      name="vehicleCategory"
                      id="vehicleCategory"
                    >
                      <option value="">--Select Vehicle Category--</option>
                      {['GOODS CARRIER'].includes(payLoad.vehicleClass) ? (
                        <>
                          <option value="LIGHT GOODS VEHICLE">LIGHT GOODS VEHICLE</option>
                          <option value="MEDIUM GOODS VEHICLE">MEDIUM GOODS VEHICLE</option>
                          <option value="HEAVY GOODS VEHICLE">HEAVY GOODS VEHICLE</option>
                        </>
                      ) : (
                        <>
                          <option value="LIGHT PASSENGER VEHICLE">LIGHT PASSENGER VEHICLE</option>
                          <option value="MEDIUM PASSENGER VEHICLE">MEDIUM PASSENGER VEHICLE</option>
                          <option value="HEAVY PASSENGER VEHICLE">HEAVY PASSENGER VEHICLE</option>
                        </>
                      )}
                    </select>
                  </div>
                </div>
              </div>

              <div className="row">
                <div className="col-sm-6">
                  {/* <!-- permit type --> */}
                  <div className="form__control">
                    <label
                      className="form__label d-block w-100 text-left"
                      htmlFor="serviceType"
                    >
                      Service Type<sup>*</sup>
                    </label>
                    <select
                      required
                      tabIndex="12"
                      disabled={isLoading}
                      value={payLoad.serviceType}
                      onChange={onChangeHandler}
                      name="serviceType"
                      id="serviceType"
                    >
                      <option value="">--Select Service Type--</option>
                      <option value="NOT APPLICABLE">NOT APPLICABLE</option>
                      <option value="ORDINARY">ORDINARY</option>
                      <option value="AIR CONDITIONED">AIR CONDITIONED</option>
                      <option value="LUXURY">LUXURY</option>
                    </select>
                  </div>
                </div>
                <div className="col-sm-6">
                  {/* <!-- permit type --> */}
                  <div className="form__control">
                    <label
                      className="form__label d-block w-100 text-left"
                      htmlFor="permitType"
                    >
                      Permit Type<sup>*</sup>
                    </label>
                    <select
                      required
                      tabIndex="13"
                      disabled={isLoading}
                      value={payLoad.permitType}
                      onChange={onChangeHandler}
                      name="permitType"
                      id="permitType"
                    >
                      <option value="">--Select Permit Type--</option>
                      <option value="NOT APPLICABLE">NOT APPLICABLE</option>
                      {fields.jharkhand.permitType.map((type) => {
                        return (
                          <option key={type.name} value={type.name}>
                            {type.name}
                          </option>
                        );
                      })}
                    </select>
                  </div>
                </div>
              </div>

              <div className="row">
                <div className="col-sm-6">
                  {/* <!-- insurance validity --> */}
                  <div className="form__control">
                    <label
                      className="form__label d-block w-100 text-left"
                      htmlFor="insuranceValidity"
                    >
                      Insurance Validity<sup>*</sup>
                    </label>
                    <input
                      tabIndex="14"
                      required
                      disabled={isLoading}
                      className="form__input w-100"
                      type="date"
                      id="insuranceValidity"
                      name="insuranceValidity"
                      onChange={onChangeHandler}
                      value={payLoad.insuranceValidity}
                    />
                  </div>
                </div>
                <div className="col-sm-6">
                  {/* <!-- pucc validity --> */}
                  <div className="form__control">
                    <label
                      className="form__label d-block w-100 text-left"
                      htmlFor="puccValidity"
                    >
                      PUCC Validity<sup>*</sup>
                    </label>
                    <input
                      tabIndex="15"
                      required
                      disabled={isLoading}
                      className="form__input w-100"
                      type="date"
                      id="puccValidity"
                      name="puccValidity"
                      onChange={onChangeHandler}
                      value={payLoad.puccValidity}
                    />
                  </div>
                </div>
              </div>

              <div className="row">
                <div className="col-sm-6">
                  {/* <!-- fitness validity --> */}
                  <div className="form__control">
                    <label
                      className="form__label d-block w-100 text-left"
                      htmlFor="fitnessValidity"
                    >
                      Fitness Validity<sup>*</sup>
                    </label>
                    <input
                      tabIndex="16"
                      required
                      disabled={isLoading}
                      className="form__input w-100"
                      type="date"
                      id="fitnessValidity"
                      name="fitnessValidity"
                      onChange={onChangeHandler}
                      value={payLoad.fitnessValidity}
                    />
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-sm-6">
                  {/* <!-- Tax From Date --> */}
                  <div className="form__control">
                    <label
                      className="form__label d-block w-100 text-left"
                      htmlFor="taxFromDate"
                    >
                      Tax From Date<sup>*</sup>
                    </label>
                    <input
                      tabIndex="13"
                      required
                      disabled={isLoading}
                      className="form__input w-100"
                      type="datetime-local"
                      id="taxFromDate"
                      name="taxFromDate"
                      onChange={onChangeHandler}
                      value={payLoad.taxFromDate}
                    />
                  </div>
                </div>
                <div className="col-sm-6">
                  {/* <!-- Tax upto Date --> */}
                  <div className="form__control">
                    <label
                      className="form__label d-block w-100 text-left"
                      htmlFor="taxUptoDate"
                    >
                      Tax upto Date<sup>*</sup>
                    </label>
                    <input
                      tabIndex="14"
                      required
                      disabled={isLoading}
                      className="form__input w-100"
                      type="datetime-local"
                      id="taxUptoDate"
                      name="taxUptoDate"
                      value={payLoad.taxUptoDate}
                      onChange={onChangeHandler}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* =============== table ======================== */}
          <div className="row mt-3">
            <div className="col-12">
              <table className="hr-table">
                <thead>
                  <tr>
                    <th className="hr-table-1">S. No.</th>
                    <th className="hr-table-2">Tax/Fee Particulars</th>
                    <th>Tax From</th>
                    <th>Tax Upto</th>
                    <th>₹ Amount</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td className="hr-table-body">1</td>
                    <td className="hr-table-body">MV Tax</td>
                    <td className="hr-table-body">
                      {payLoad.taxFromDate
                        ? payLoad.taxFromDate.split("T")[0]
                        : ""}
                    </td>
                    <td className="hr-table-body">
                      {payLoad.taxUptoDate
                        ? payLoad.taxUptoDate.split("T")[0]
                        : ""}
                    </td>
                    <td className="hr-table-body">
                      <input
                        type="number"
                        className="form__input"
                        name="mvTax"
                        value={payLoad.mvTax}
                        onChange={onChangeHandler}
                        required
                        min="0"
                        inputMode="numeric"
                      />
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <br />
          {/* =================== total ====================== */}
          <div className="row">
            <div className="col-sm-6">
              {/* <!-- Total amount --> */}
              <div className="form__control">
                <label
                  className="form__label d-block w-100 text-left"
                  htmlFor="totalAmount"
                >
                  Total amount<sup>*</sup>
                </label>
                <input
                  tabIndex="15"
                  required
                  disabled={isLoading}
                  onChange={onChangeHandler}
                  value={payLoad.totalAmount}
                  className="form__input w-100"
                  type="text"
                  id="totalAmount"
                  name="totalAmount"
                />
              </div>
            </div>
            <div className="col-sm-6">
              <label className="form__label d-block w-100 text-left">
                &nbsp;
              </label>
              <ActionButtons
                tabIndex="16"
                isDisabled={isLoading}
                onReset={onResetHandler}
              />
            </div>
          </div>
        </form>
        <br />
      </div>
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
    </>
  );
};

export default Jharkhand;
